export default import.meta.ROLLDOWN_FILE_URL_f$_5FvhUJDgtNju7Qh$rhg